export default {
    name: 'renderHead',
    functional: true,
    props: {
        render: Function,
        index: Number,
        column: {
            type: Object,
            default: null
        }
    },
    render: (h, ctx) => {
        const params = {
            column: ctx.props.column,
            index: ctx.props.index
        };
        return ctx.props.render(h, params);
    }
};


//////////////////
// WEBPACK FOOTER
// ./packages/table/headRender.js
// module id = null
// module chunks = 